export default "__VITE_ASSET__WsYH5p9v__"